import { deleteEHRAppointment } from '@ax/service';
import { DeleteEHRAppointmentInput } from '@ax/service/src/ehr-interface';
import { useMutation } from '@tanstack/react-query';

export function useDeleteEHRAppointmentApi() {
  const deleteEHRAppointmentMutation = useMutation({
    mutationKey: ['delete-ehr-appointment'],
    mutationFn: (data: DeleteEHRAppointmentInput) => deleteEHRAppointment(data),
    onError: (error: any) => {
      return error;
    },
  });

  return deleteEHRAppointmentMutation;
}
